<template>
  <page status="reproved" :title="i18n('Cadastros reprovados')" :description="i18n('cadastros reprovados')" />
</template>

<script>
import CustomersList from "./CustomersList"
export default {
  name: 'CustomersListReproved',
  components: { 'page': CustomersList },
  data() {
    return {}
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/CustomersListReproved.vue